module.exports = __webpack_public_path__ + "img/man-botnari.499b5885.png";